export default {
  title: 'Mit {{method}} bezahlen',
  hint: 'Als Nächstes bestätigst du die Zahlung bei deiner Bank oder in deiner App.',
  continue: 'Weiter',
  cancel: 'Zahlung abbrechen',
  unavailable: 'Diese Zahlungsart ist gerade nicht verfügbar. Wähle eine andere.',
};
